import * as React from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { useRecoilState } from 'recoil'
import { snackbarState } from 'src/store/global/snackbarState';


const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function SnackbarCustom({
    autoHideDuration = 5000,
    openAlert,
    severity = "success",
    text,
    position = { vertical: 'top', horizontal: 'right' }
}) {
    const [, setSnackbar] = useRecoilState(snackbarState);

    const handleClose = () => {
        setSnackbar(null);
    };

    return (
        <div>
            <Snackbar 
                anchorOrigin={{ ...position }} 
                open={openAlert ? true : false} 
                autoHideDuration={autoHideDuration} 
                onClose={handleClose}
            >
                <Alert onClose={handleClose} severity={severity} sx={{ width: '100%' }}>
                    {text}
                </Alert>
            </Snackbar>
        </div>
    );
}